export default __webpack_public_path__ + "static/media/ResumeImg.fb026eac.jpg";